import { render, staticRenderFns } from "./VoiceInputView.vue?vue&type=template&id=67f5ad16&scoped=true&"
import script from "./VoiceInputView.vue?vue&type=script&lang=js&"
export * from "./VoiceInputView.vue?vue&type=script&lang=js&"
import style0 from "./VoiceInputView.vue?vue&type=style&index=0&id=67f5ad16&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f5ad16",
  null
  
)

export default component.exports